import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, Box, Container, Hidden } from "@material-ui/core";
import TopBar from "../DashboardLayout/TopBar/index";
import ActingAsBanner from "src/component/ActingAsBanner";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.main,
    minHeight: "100dvh",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    paddingTop: 70,
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    background: theme.palette.background.dark1,
    flexDirection: "row",  // Ensure the content container is row on larger screens
    [theme.breakpoints.down("sm")]: { // Adjust for smaller screens
      flexDirection: "column",
    },
  },
  Sidebar: {
    width: "240px",
    [theme.breakpoints.down("sm")]: {
      width: "100%", // For mobile, use full width
      display: "none", // Hide Sidebar for mobile
    },
  },
  content: {
    flex: "1 1 auto",
    position: "relative",
    padding: "0px 0px 15px 10px ",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
      maxWidth: "100%",
    },
  },
  table: {
    width: "100%",
    // You can also add other general styles here
  },
  tableCell: {
    fontSize: "14px",
    padding: "16px",
    [theme.breakpoints.down('sm')]: { // Sm breakpoint (for mobile/tablets)
      fontSize: "12px",
      padding: "8px",
    },
  },
  
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <ActingAsBanner />

      <div className={classes.wrapper}>
        <Container maxWidth="lg">
          <div className={classes.contentContainer}>
            <div className={classes.content} id="main-scroll">
              {children}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
